<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
  name: 'GroupOneRaceHeader',
  props: {
    meeting: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      eventData: 'GroupOneRaceTips/getEventInfo',
    }),
    formattedDate() {
      return moment(this.eventInfo.date).format('dddd MMMM Do');
    },
    eventInfo() {
      return this.eventData || {};
    },
  },
};
</script>

<template>
  <div class="group-one-race-header">
    <div class="group-one-race-header__meeting-info">
      <div class="group-one-race-header__meeting-info-container">
        <div class="group-one-race-header__meeting-image">
          <img src="https://puntcdn.com/icons/group-one/grey-icons/calendar_icon.svg" >
        </div>
        <div class="group-one-race-header__meeting-text">{{ formattedDate }}</div>
      </div>
      <div class="group-one-race-header__meeting-info-container">
        <div class="group-one-race-header__meeting-image">
          <img src="https://puntcdn.com/icons/group-one/grey-icons/race_class_icon.svg" >
        </div>
        <div class="group-one-race-header__meeting-text">{{ eventInfo.entryConditions }}</div>
      </div>
      <div class="group-one-race-header__meeting-info-container">
        <div class="group-one-race-header__meeting-image">
          <img src="https://puntcdn.com/icons/group-one/grey-icons/prize_money_icon.svg" >
        </div>
        <div class="group-one-race-header__meeting-text">{{ eventInfo.prize }}</div>
      </div>
      <div class="group-one-race-header__meeting-info-container">
        <div class="group-one-race-header__meeting-image">
          <img src="https://puntcdn.com/icons/group-one/grey-icons/track_distance_icon.svg" >
        </div>
        <div class="group-one-race-header__meeting-text">{{ eventInfo.trackInfo }}</div>
      </div>
    </div>
  </div>
</template>
